module.exports = __webpack_public_path__ + "static/media/Jumbotronpic_3.a99db56c.jpg";